<template>
    <div class="ses-modal-wrap" v-if="spinfo" id="SellingPoint">
        <a class="ses-modal-bd"></a>
        <div class="ses-modal" style="width: 710px;">
            <div class="ses-modal-head"> Additional Components / Services</div>
            <div class="ses-modal-body">
                <form id="floor-form" >
                    <input type="hidden" v-model="reseter.counter">
                    <input type="hidden" v-model="step">
                    <p>We can offer the following additional components / services for you, please check any you'd be interested in.</p>
                    <ul>
                        <li><label><input type="checkbox" v-model="spinfo.guide_rails"> Guide Rails and Hardware</label></li>
                        <li><label><input type="checkbox" v-model="spinfo.hoistway_components"> Hoistway Components (Governor, Roller Guides, Safety, Oil Buffer)</label></li>
                        <li><label><input type="checkbox" v-model="spinfo.more_info"> Interested in more Information on existing equipment removal services</label></li>
                        <li><label><input type="checkbox" v-model="spinfo.liftnet_info"> Interested in more Information on LiftNet monitoring and control</label></li>
                    </ul>
                </form>
            </div>
            <div class="ses-modal-foot">
                <a class="btn btn-black" @click="saveSP">Next</a>
            </div>
        </div>
    </div>
</template>
<script>

  export default {
    name: "doorfloorInfo",
    props: {
      spinfo: {
        type: [String, Object, Array, Boolean],
        default: "",
        description: "Model"
      },
    },
    data() {
      return {
        step: 1,
        toggled: false,
        rear: false,
        reseter: { counter : 1 },
        duplicator: {},
      };
    },
    watch: {
        spinfo: {
            handler: function(data) {
                if ( data ) {
                    console.log(data);
                }

            },
            deep: true
        }
    }, 
    methods: {
        reset(){
            var ctr = this.reseter.counter;
            this.$set(this.reseter,'counter',ctr+2);
            this.$set(this.reseter,'counter',ctr+1);
        },
        closeModal() {
            if ( confirm('Data changes will be lost if not saved.') ) {
                this.$emit('closeinfo');
            }
        },
        showItems() {
            ++this.step;
        },
        saveSP() {
            this.$emit('saveinfo', this.spinfo);
        }
    }
};
</script>
<style>
    .ses-modal-wrap { position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; z-index: 99999; }
    .ses-modal-bd { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,.5); }
    .ses-modal { position: absolute; top: 50%; left: 50%; width: 940px; max-width: calc(100% - 60px); height: auto; transform: translate(-50%,-50%); background: #FFF; border-radius: 6px; overflow: hidden; }
    .ses-modal-head { color: #fff; font-size: 19px; text-shadow: 1px 1px 3px #000; text-align: center; background: #333; padding: 14px 20px; min-height: 16.43px; }
    .ses-modal-body { position: relative; padding: 15px; max-height: calc(100vh - 160px); overflow: auto;}
    .ses-modal-foot { padding: 15px; text-align: right; border-top: 1px solid #e5e5e5; }
    .modal-step { padding: 0 15px; }
</style>